import { Box, Stack, useTheme } from "@mui/material";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { PublicationApprovalStatus } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { useCardContext } from "../../CardBuilder";
import { CardContextLink } from "../../CardContextLink";
import { DefaultModerationClassification } from "../common/DefaultModerationClassification";
import { StickerBox } from "../common/StickerBox";
import { ThreadItemClassification } from "../common/ThreadItemClassification";

///
export const FeedMyContributionsThreadClassification = () => {

    const { pub } = useCardContext();

    if (pub.approvalStatus != PublicationApprovalStatus.Approved)
        return <DefaultModerationClassification />;

    return <ThreadItemClassification />;
};

///
export const FeedMyContributionsThreadTitle = () => {
    const { pub, pub: { masterPublication } } = useCardContext();
    const theme = useTheme();
    const { t } = useTranslation("knowledge");
    const navigateUrl = KnowledgePaths.PublicationViewerResolver(pub.publicationId, pub.publicationType, pub.masterPublication?.publicationId);

    return (
        <div>
            {navigateUrl == document.location.pathname
                ? (
                    <Box sx={{ color: theme.palette.common.black }}>
                        <MprcFeedTypography variant="title" component="div" noWrap={true} color={"inherit"}>
                            <span title={pub.title}>{pub.title}</span>
                        </MprcFeedTypography>
                    </Box>
                )
                : (
                    <CardContextLink
                        publicationId={pub.publicationId}
                        to={navigateUrl}
                    >
                        <Box sx={{ color: theme.palette.common.black }}>
                            <MprcFeedTypography variant="title" component="div" noWrap={true} color={"inherit"}>
                                <span title={pub.title}>{pub.title}</span>
                            </MprcFeedTypography>
                        </Box>
                    </CardContextLink>

                )
            }
            <Stack spacing={0.5} alignItems="flex-end" direction="row">
                {(masterPublication?.isAvailable === false) &&
                    <StickerBox
                        name={t("Feed.Card.Common.MasterUnavailableText")}
                        textColor={theme.palette.common.white}
                        backgroundColor={theme.palette.error.main}
                        variant="stickerLowercase"
                    />
                }
            </Stack>
        </div>
    );
};
